angular.module('impactx.dashboard').controller('DashboardFeedReaderCtrl', ['$scope', 'dataGen', '$redirect', DashboardFeedReaderCtrl]);

function DashboardFeedReaderCtrl($scope, dataGen, $redirect) {
    this.selectedMessageType = {};
    this.selectedMessage = {};
    this.selectedChannel = {};
    this.selectedFeed = {};

    $scope.loading = true;

    dataGen.getData($scope, {}, "/dashboard/view/newsreader").then(function() {
        $scope.messageTypes = $scope.data.feedreader.messageTypes;
        $scope.channels = $scope.data.feedreader.channels;
        $scope.loading = false;
    });

    this.setSelectedChannel = function(channel) {
        this.deselectMessageTypes();
        this.deselectChannels();
        channel.selected = true;
        this.selectedChannel = channel;
    };

    this.setSelectedMessage = function(message) {
        angular.forEach($scope.messageTypes, function(messageType) {
            angular.forEach(messageType.messages, function(entry) {
                entry.selected = false;
            });
        });
        message.selected = true;
        this.selectedMessage = message;
    };

    this.setSelectedMessageType = function(messageType) {
        this.deselectChannels();
        this.deselectMessageTypes();
        messageType.selected = true;
        this.selectedMessageType = messageType;
    };

    this.setSelectedFeed = function(feed) {
        angular.forEach($scope.channels, function(channel) {
            angular.forEach(channel.feeds, function(entry) {
                entry.selected = false;
            });
        });
        feed.selected = true;
        this.selectedFeed = feed;
    };

    this.deselectChannels = function() {
        angular.forEach($scope.channels, function(channel) {
            channel.selected = false;
            angular.forEach(channel.feeds, function(entry) {
                entry.selected = false;
            });
        });
        this.selectedFeed = {};
        this.selectedChannel = {};
    };

    this.deselectMessageTypes = function() {
        angular.forEach($scope.messageTypes, function(messageType) {
            messageType.selected = false;
            angular.forEach(messageType.messages, function(entry) {
                entry.selected = false;
            });
        });
        this.selectedMessageType = {};
        this.selectedMessage = {};

    };

    this.openLink = function(id) {
        $redirect.redirectTo(null, '/message/' + id);
    };
}
